import { Add } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import { Button, Grid } from "@mui/material";
import {
  default as DialogAddReminderType,
  default as DialogEditReminderType,
} from "admin/components/resources/field_management/reminders/form";

import PageTitle from "admin/layout/PageTitle";
import { useCallback, useState } from "react";
import {
  BooleanField,
  Datagrid,
  List,
  TextField,
  useRecordContext,
} from "react-admin";

const ListActions = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return (
    <Grid container direction={"row-reverse"}>
      <Grid item>
        <Button color={"primary"} onClick={handleOpen} startIcon={<Add />}>
          Nouveau type de rappel
        </Button>
        <DialogAddReminderType open={open} handleClose={handleClose} />
      </Grid>
    </Grid>
  );
};

const EditReminders = () => {
  const record = useRecordContext();

  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return (
    <Grid container direction={"row-reverse"}>
      {/* {record['@id']} */}
      <Grid item>
        <Button
          color={"primary"}
          onClick={handleOpen}
          startIcon={<EditIcon />}
        ></Button>
        <DialogEditReminderType
          open={open}
          id={`edit_${record["@id"]}`}
          handleClose={handleClose}
        />
      </Grid>
    </Grid>
  );
};

const RemindersList = () => (
  <List
    hasShow={false}
    hasEdit={false}
    empty={false}
    actions={<ListActions />}
    title={<PageTitle>Mes rappels</PageTitle>}
  >
    <Datagrid bulkActionButtons={false}>
      <TextField source={"code"} label={"Code"} />
      <TextField source={"label"} label={"Label"} />
      <BooleanField source={"active"} label="Actif" />
      <EditReminders />
      {/* <ShowButton resource={"collaborators"} label={""} /> */}
    </Datagrid>
  </List>
);

export default RemindersList;
